import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TreeModule} from '@ali-hm/angular-tree-component';
import {TreeListComponent} from './components/tree/tree-list.component';
import {SharedModule} from '@shared/shared.module';
import {CheckboxModule} from '@shared/modules/form/modules/checkbox/checkbox.module';
import {ButtonsModule} from '@shared/modules/buttons/buttons.module';
import { NgScrollbarModule } from 'ngx-scrollbar';


@NgModule({
  declarations: [TreeListComponent],
  exports: [
    TreeListComponent
  ],
  imports: [
    CommonModule,
    TreeModule,
    SharedModule,
    CheckboxModule,
    ButtonsModule,
    NgScrollbarModule,
  ]
})
export class AppTreeModule { }
